import { useState, useImperativeHandle, FC, useEffect } from 'react';
import BaseModal from '@/components/BaseModal';
import './index.scss';
import '@/scss/quill.bubble.css';
import Apis from '@/api';

interface propsType {
  cRef?: any;
}
const SignInExplain: FC<propsType> = (props) => {
  const { cRef } = props;
  const [show, setShow] = useState<boolean>(false); //是否展示
  const [desc, setDesc] = useState<any>(null); //是否展示
  /**
   * @description: 切换弹框状态
   */
  const open = () => {
    setShow(true);
  };
  /**
   * @description: 关闭
   */
  const close = () => {
    setShow(false);
  };
  // 绑定ref
  useImperativeHandle(cRef, () => ({
    open,
  }));
  useEffect(() => {
    (async () => {
      if (show) {
        const res: any = await Apis.signIn.queryDesc();
        setDesc(res);
      }
    })();
  }, [show]);
  return (
    <BaseModal show={show}>
      <div className="signin-explain">
        <img
          src={require('@/images/signIn/icon_close.png')}
          alt=""
          className="explain__close"
          onClick={close}
        />
        <p className="explain__title">活动说明</p>
        <div
          className="explain__tips ql-editor"
          dangerouslySetInnerHTML={{ __html: desc }}
        >
          {/* <div className='explain__tips__item'>
            <p className='explain__tips__item__title'>1.说明标题</p>
            <p className='explain__tips__item__content'>1.这里是活动说明这里是活动说明这里是活动说明这里是活动说明 </p>
            <p className='explain__tips__item__content'>2.这里是活动说明这里是活动说明这里是活动说明这里是活动说明这里是活动说明这里是活动说明这里是活动说明</p>
          </div> */}
        </div>
      </div>
    </BaseModal>
  );
};

export default SignInExplain;
